import Founders from '../../../website-mobile/components/Founders/Founders';
import '../../../website-mobile/mobile-scope.css';
import styles from './page7.module.css';

export default function Page7() {
    return (
        <div className={`${styles.page7} website-mobile-scope`}>
            <div className={styles.contentWrapper}>
                <Founders />
            </div>
        </div>
    );
}
